import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Sidebar/DashboardLayout';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import TableFilterControls from '../../commun/TableFilterControls';
import ActionButtons from '../../commun/ActionButtons';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import axios from 'axios';
import { Dialog, DialogContent } from '@mui/material';
import DetailTalent from '../../Recruteur/candidat/detailTalent/detailTalent';
import CandidatureDetailsCommon from '../../commun/CandidatureDetailsCommon';
import { useNavigate } from 'react-router-dom';
import Chatbox from '../../commun/ChatBox';
import { entrepriseCandidatureStatus } from '../../commun/constants/options';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CandidaturesDashboard = () => {
  const [displayMode, setDisplayMode] = useState('table');
  const [candidatures, setCandidatures] = useState([]);
  const [id, setId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;
  const [statusFilter, setStatusFilter] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCandidatureDetail, setShowCandidatureDetail] = useState(false);
  const [selectedTalentId, setSelectedTalentId] = useState(null);
  const [candidature, setCandidature] = useState(null);
  const [editedStatut, setEditedStatut] = useState(null);
  const authToken = localStorage.getItem('authToken')
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');
  const candidaturesPerPage = 5 ;

  useEffect(() => {
    fetchCandidatures();
  }, []);

    useEffect(() => {
      if (!authToken) return navigate('/');
      if (!id) return;
      const fetchData = async () => {
        try {
          const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          const data = await res.json();
          setCandidature(data);
          setEditedStatut(data.statut);
        } catch (err) {
        }
      };
      fetchData();
    }, [id]);
  
  const fetchCandidatures = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/candidatures/all`); 
      setCandidatures(response.data);
    } catch (error) {
      console.error('Erreur de récupération des candidatures:', error);
    }
  };

  const handleDelete = async (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${API_BASE}/api/candidatures/${id}`);
          await fetchCandidatures(); 
        } catch (error) {
          console.error('Erreur suppression candidature:', error);
        }
      },
      onCancel: () => {},
    });
  };
  

  const filteredCandidatures = candidatures.filter(candidature => {
    const entrepriseName = candidature.entrepriseId?.NomEntreprise || '';
    const recruteurName = candidature.recruteurId 
      ? `${candidature.recruteurId.firstName || ''} ${candidature.recruteurId.lastName || ''}`
      : '';
    const statut = candidature.statut || '';
  
    return (
      (entrepriseName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      recruteurName.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (statusFilter ? statut === statusFilter : true)
    );
  });
  
  

  const paginatedCandidatures = filteredCandidatures.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const columns = [
    { key: 'reference', label: 'Candidat' },
    { key: 'NomEntreprise', label: 'Entreprise' },
    { key: 'nomMission', label: 'Mission' },
    { key: 'dateCandidature', label: 'Date de candidature' },
    {
      key: 'statut',
      label: 'Statut',
      render: (_, row) => {
        const rawStatus = row.statut || 'Non défini';
    
        const matched = entrepriseCandidatureStatus.find((s) => s.value === rawStatus);
    
        if (matched) {
          return <span className="status-badge" style={matched.style}>{matched.label}</span>;
        } else {
          return <span className="status-badge">{rawStatus}</span>; 
        }
      }
    }
  ];

  const tableData = paginatedCandidatures.map((c) => ({
    reference: c.candidatId?.reference || 'N/A',
    NomEntreprise: c.entrepriseId?.NomEntreprise || 'N/A',
    nomMission: c.missionId?.nomMission || 'N/A',           
    dateCandidature: (c.dateEnvoi || c.dateCandidature || c.createdAt) && !isNaN(new Date(c.dateEnvoi || c.dateCandidature || c.createdAt))
  ? new Date(c.dateEnvoi || c.dateCandidature || c.createdAt).toLocaleDateString('fr-FR')
  : '—',
    statut: c.statut || 'En attente',
    _id: c._id
  }));
  
  const handleView = (candidatureId) => {
    setId(candidatureId);
    setShowCandidatureDetail(true);
  };

  return (
    <section className="dashboardContainer">
      <div className="headerTalentWrapper">
        <h3 className="componentTitle">Liste des candidatures</h3>
        <div className="top-controlsC">
        <TableFilterControls
        searchValue={searchTerm}
        onSearchChange={setSearchTerm}
        statusValue={statusFilter}
        onStatusChange={setStatusFilter}
        statusLabel="Statut"
        statusOptions={entrepriseCandidatureStatus}
      />

        </div>
      </div>

      <GenericTable
        displayMode={displayMode}
        setDisplayMode={setDisplayMode}
        columns={columns}
        data={tableData}
        totalItems = {candidatures.length}
        renderActions={(row) => (
          <ActionButtons
            onDelete={() => handleDelete(row._id)}
            showEdit={false}
            showDownload={false}
            onView={() => handleView(row._id)}
          />
        )}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />

    <Dialog
        open={showCandidatureDetail} 
        onClose={() => setShowCandidatureDetail(false)} 
        fullWidth 
        maxWidth="lg"
      >
        <DialogContent style={{ padding: 0 }}>
        <CandidatureDetailsCommon
          HeaderComponent={null}
          headerProps={{ entrepriseName: localStorage.getItem('entrepriseName'), authToken}}
          candidature={candidature}
          editedStatut={editedStatut}
          setEditedStatut={setEditedStatut}
          API_BASE={API_BASE}
          editable={false}
        />
        </DialogContent>
      </Dialog>
      <Pagination page={page} setPage={setPage} totalItems={filteredCandidatures.length} itemsPerPage={candidaturesPerPage}/>
              {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </section>
  );
};

// Final Export
const Candidatures = () => (
  <DashboardLayout>
    <CandidaturesDashboard />
  </DashboardLayout>
);

export default Candidatures;
